import { render, staticRenderFns } from "./EditAreas.vue?vue&type=template&id=879813ac&scoped=true"
import script from "./EditAreas.vue?vue&type=script&lang=js"
export * from "./EditAreas.vue?vue&type=script&lang=js"
import style0 from "./EditAreas.vue?vue&type=style&index=0&id=879813ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879813ac",
  null
  
)

export default component.exports